import type { IAccountingAccount } from './types'

export const getAccountOptions = (accounts: IAccountingAccount[]) => {
  const options: Record<string, string> = {}
  accounts.forEach((v) => {
    options[`${v.id}`] = `${v.name} ····${v.number.substring(v.number.length - 4)}`
  })
  return options
}
